(function () {
  'use strict';

  angular.module('app').component('transportationContentDetail', transportationContentDetail());

  function transportationContentDetail() {
    return {
      bindings: {
        item: '=',
        transportationId: '<',
        onTransportationContentSaved: '&',
        onTransportationContentCanceled: '&',
        websiteId: '<',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: TransportationContentDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-contents/transportation-content-detail/transportation-content-detail.component.html',
    };
  }

  TransportationContentDetailComponent.$inject = [
    'UtilService',
    'SessionService',
    'TransportationContentService',
    'TransportationService',
    'TagService',

    // Angular downgraded service
    'ng2Router',
  ];

  function TransportationContentDetailComponent(
    UtilService,
    SessionService,
    TransportationContentService,
    TransportationService,
    TagService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);
    let cropedImage = { file: null };

    // Methods
    vm.tagTransform = tagTransform;
    vm.checkTagOptions = checkTagOptions;

    vm.selectParentTransportation = selectParentTransportation;
    vm.updateSeoTitle = updateSeoTitle;
    vm.setSeoTitle = setSeoTitle;
    vm.updateSeoDescription = updateSeoDescription;
    vm.setSeoDescription = setSeoDescription;

    //vm.editTransportationContent = editTransportationContent;
    vm.cancelEdit = cancelEdit;
    vm.saveTransportationContent = saveTransportationContent;
    vm.cancel = cancel;
    vm.openTransportationContentTranslation = openTransportationContentTranslation;
    vm.openLogo = openLogo;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        vm.editMode = true;

        vm.flashMessage = vm.UtilService._displayFlashMessage();

        vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

        vm.itemName = vm.item.name;
        vm.labelAddLogo = vm.item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';
        vm.originalItem = angular.copy(vm.item);
      } else {
        // New
        if (vm.transportationId) {
          vm.item.transportation_id = vm.transportationId; // optional from modal
        }

        vm.item.website_id = vm.websiteId;
        vm.isUrlRequired = false;
        vm.item.url = '';

        vm.item.published = false;

        vm.labelAddLogo = 'ADD_PHOTO';
      }

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
      vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

      // Initializers
      getTransportationsContents();
      getTags(vm.defaultLanguage);
    };

    function cancelEdit() {
      vm.cancel();
    }

    function getTransportations(transportationIds) {
      TransportationService.getTransportations({ get: 'selector', skip_check_role: true }).then(
        function (data) {
          vm.transportations = [];

          data.items.forEach(function (transportation) {
            for (var i = 0; i < transportationIds.length; i++) {
              var transportationId = transportationIds[i];
              if (transportation.id === transportationId) {
                if (vm.item.transportation_id === transportationId) {
                  transportation.current = true;
                } else {
                  transportation.inUse = true;
                }

                break;
              }
            }

            vm.transportations.push(transportation);
          });
        }
      );
    }

    function getTransportationsContents() {
      var filterCriteria = {
        get: 'active',
        skip_check_role: true,
      };

      TransportationContentService.getTransportationsContents(
        vm.item.website_id,
        filterCriteria
      ).then(function (data) {
        var transportationIds = [];

        data.items.forEach(function (content) {
          transportationIds.push(content.transportation_id);
        });

        getTransportations(transportationIds);
      });
    }

    function selectParentTransportation(transportation) {
      if (!vm.item.id) {
        // Create mode
        vm.item.name = transportation.name;
        updateSeoTitle();
      }
    }

    // ----- SEO ----- //
    function updateSeoTitle() {
      if (!vm.item.seo_title_filled) {
        vm.item.seo_title = vm.item.name;
      }
    }

    function setSeoTitle() {
      vm.item.seo_title_filled = vm.item.seo_title ? true : false;
    }

    function updateSeoDescription() {
      if (!vm.item.seo_description_filled) {
        vm.item.seo_description = vm.item.description.replace(/<\/?[^>]+(>|$)/g, ''); // text only
      }
    }

    function setSeoDescription() {
      vm.item.seo_description_filled = vm.item.seo_description ? true : false;
    }

    function openLogo() {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          TransportationContentService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      TransportationContentService.openLogo(vm.item, logoSaved);
    }

    // ----- TAGS -----

    function getTags(lang) {
      TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
        vm.tags = data.items;
      });
    }

    function tagTransform(name) {
      return TagService.tagTransform(name, vm.defaultLanguage);
    }

    function checkTagOptions(tag) {
      vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
    }

    // Create / udpate transportation content
    function saveTransportationContent(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid || vm.item.url === '') {
        vm.isUrlRequired = true;
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var successCallback = function () {
        vm.sendingForm = true;
        TransportationContentService.saveTransportationContent(
          vm.item,
          vm.defaultLanguage,
          cropedImage
        ).then(
          function (response) {
            var response = response.data;

            vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(response.url_video);

            if (!vm.editMode) {
              // Create
              vm.onTransportationContentSaved({ item: response });
            } else {
              // Edit
              vm.flashMessage = vm.UtilService._clearFlashMessage();

              vm.itemName = response.name;
              vm.originalItem = angular.copy(vm.item);
            }

            vm.sendingForm = false;

            vm.UtilService.scrollToTop();
          },
          function (response) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

            if (response.data.error) {
              vm.serverErrors.publish = response.data.error;
            }

            vm.formErrors = true;
            vm.UtilService.scrollToTop();

            vm.sendingForm = false;
          }
        );
      };

      const callback = (response) => {
        if (response === 'edit') {
          vm.UtilService.scrollToTop();

          return;
        }

        if (response === 'generate') {
          vm.item.url = UtilService.prototype.generateURL(vm.item);
        }

        successCallback();
      };

      if (vm.item.id && vm.item.name !== vm.originalItem.name) {
        vm.UtilService.openProductsChangeUrlModal(callback);
      } else {
        successCallback();
      }
    }

    function cancel() {
      vm.onTransportationContentCanceled({ item: vm.item });
    }

    function openTransportationContentTranslation() {
      TransportationContentService.openTransportationContentTranslation(
        vm.item.id,
        vm.websiteName,
        vm.additionalLanguages
      );
    }

    function isUrlValid() {
      if (vm.item.url === '') vm.isUrlRequired = true;
      return;
    }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };
  }
})();
